import { useEffect, useMemo, useState } from "react";
import { toast } from "react-hot-toast";
import { getAllTills } from "@/api/new-api/settings/device-management";
import useAuth from "@/hooks/useAuth";

const getRestaurantId = (user) =>
  user?.restaurant_id || Number(localStorage.getItem("restaurant_id")) || null;

const normalizeTills = (payload) =>
  Array.isArray(payload?.data?.tills) ? payload.data.tills : [];

export const useReportTills = () => {
  const { user } = useAuth();
  const restaurantId = useMemo(() => getRestaurantId(user), [user?.restaurant_id]);
  const [tills, setTills] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!restaurantId) return;

    let isActive = true;
    setIsLoading(true);

    getAllTills(restaurantId)
      .then((response) => {
        if (!isActive) return;
        if (response?.status === "success") {
          setTills(normalizeTills(response));
        } else {
          setTills([]);
          toast.error(response?.message || "Failed to load tills.");
        }
      })
      .catch(() => {
        if (!isActive) return;
        setTills([]);
        toast.error("Failed to load tills.");
      })
      .finally(() => {
        if (!isActive) return;
        setIsLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [restaurantId]);

  return { tills, isLoading };
};
